import Swiper, { Navigation, Pagination } from 'swiper';
Swiper.use([Navigation, Pagination]);
document.querySelectorAll('.post-carousel').forEach(function (carousel) {
    console.log(carousel);
    var slidesperView = 3;
    if (carousel.hasAttribute('data-slides-per-view')) {
        slidesperView = Number(carousel.getAttribute('data-slides-per-view'));
    }
    new Swiper(carousel, {
        slidesPerView: 1,
        spaceBetween: 40,
        watchSlidesProgress: true,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        breakpoints: {
            768: {
                slidesPerView: slidesperView,
                spaceBetween: 20,
            },
            1100: {
                slidesPerView: slidesperView,
                spaceBetween: 80,
            },
        },
    });
});
